import { useCallback, useEffect, useRef } from 'react';
import { useBeforeUnload, useBlocker } from 'react-router-dom';

type Props = {
  message: string;
};

export default function BlockPageNavigation({ message }: Props): JsxNode {
  const blockerFunction = useCallback(() => !window.confirm(message), [message]);
  const blocker = useBlocker(blockerFunction);
  const prevState = useRef(blocker.state);
  useEffect(() => {
    if (blocker.state === 'blocked') {
      blocker.reset();
    }
    prevState.current = blocker.state;
  }, [blocker]);

  useBeforeUnload(
    useCallback((event) => {
      event.preventDefault();
      event.returnValue = '';
    }, []),
    { capture: true }
  );

  return null;
}
